import React, {Component} from "react";
import PropTypes from "prop-types";

class Main extends Component {
    render() {
        const {children} = this.props;

        return (
            <main className="col-8 col-md-9 col-xl-10" role="main">
                {children}
            </main>
        );
    }
}

Main.propTypes = {
    children: PropTypes.any
};

export default Main;


// WEBPACK FOOTER //
// ./src/app/layout/main/Main.js